/**
 * UserSummaryBanner.js
 * Written by: Alex Kasemir
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import formatDate from 'date-fns/format';

import modalActions from 'store/modal/actions';
import userActions from 'store/user/actions';
import userSelectors from 'store/user/selectors';

import event from 'utils/event';

import {
  UserSummaryBannerContainer,
  SummarySection,
  SummaryHeader,
  SummaryInfo,
  ProfileLink,
  TrackingText,
  AuthButton,
  OrText,
} from './UserSummaryBanner.styles';


/**
 * View you submitted questions
 *
 */
export class UserSummaryBanner extends Component {
  componentDidMount() {
    const {
      getUserStats,
      session,
    } = this.props;

    if (session.authedUserId) {
      getUserStats(session.authedUserId);
    }
  }

  componentDidUpdate(prevProps) {
    const {
      getUserStats,
      session,
    } = this.props;

    if (session.authedUserId !== null && prevProps.session.authedUserId === null) {
      getUserStats(session.authedUserId);
    }
  }

  openModal = (e) => {
    const { createModal } = this.props;

    event(`open-signup-modal`, [`click`, `open-signup-modal`, e.target.name]);

    createModal({
      key: `login`,
      extraProps: {
        header: `${e.target.name}!`,
        location: e.target.name,
      },
    });
  }

  render() {
    const { stats } = this.props;

    return stats
      ? (
        <UserSummaryBannerContainer stats>
          <SummarySection stats>
            <SummaryHeader>USER SINCE:</SummaryHeader>
            <SummaryInfo>{ formatDate(stats.date_joined, `M/D/YYYY`) }</SummaryInfo>
          </SummarySection>
          <SummarySection stats>
            <SummaryHeader>QUESTIONS ANSWERED:</SummaryHeader>
            <SummaryInfo>{ stats.attempted }</SummaryInfo>
          </SummarySection>
          <SummarySection stats>
            <SummaryHeader>AVERAGE SCORE:</SummaryHeader>
            <SummaryInfo>
              { stats.attempted !== 0 ? ((stats.correct / stats.attempted) * 100).toFixed() : 0 }%
            </SummaryInfo>
          </SummarySection>
          <SummarySection>
            <ProfileLink to={`/profile/${stats.id}/preferences`}> VIEW PREFERENCES </ProfileLink>
          </SummarySection>
        </UserSummaryBannerContainer>
      )
      : (
        <UserSummaryBannerContainer>
          <TrackingText>
            TO START TRACKING YOUR PROGRESS
          </TrackingText>
          <AuthButton name="Login" onClick={ this.openModal } type="secondary">
            LOGIN
          </AuthButton>
          <OrText>
           OR
          </OrText>
          <AuthButton name="Sign Up" onClick={ this.openModal } type="secondary">
           SIGN UP
          </AuthButton>
        </UserSummaryBannerContainer>
      );
  }
}

UserSummaryBanner.propTypes = {
  createModal: PropTypes.func.isRequired,
  getUserStats: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
  stats: PropTypes.object,
};

export default connect((state) => {
  return {
    session: state.user.session,
    stats: userSelectors.selectedUserStats(state),
  };
}, {
  createModal: modalActions.createModal,
  getUserStats: userActions.getUserStats,
})(UserSummaryBanner);
